import styled from 'styled-components';

export default styled.div`
	flex: 1;
	display: flex;
	align-items: baseline;
    position: relative;
    gap: var(--spacing-x-small);
	.motif-dropdown {
		position: static;
	}
	.motif-dropdown-menu {
		right: 0 !important;
		transform: unset !important;
		min-width: unset;
	}
`;
